import { fetchData } from './../_helpers/fetchData';
var get = function () {
    return fetchData("" + process.env.REACT_APP_API_SCHEMA_PATH).then(function (response) { return ({ response: response }); }, function (error) { return ({ error: error }); });
};
export var schemaService = {
    get: get,
};
